import { render, staticRenderFns } from "./PreviousManufacturerDetailsComponent.vue?vue&type=template&id=917b30ca"
import script from "./PreviousManufacturerDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./PreviousManufacturerDetailsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports